import React, { useState } from "react";
import EISSidebar from "./EISSidebar";
import RawDataTable from "./RawDataTable";
import ParametersTable from "./ParametersTable";
import ObdUsedPanel from "./ObdUsedPanel";
import NotesPanel from "./NotesPanel";
import IntelligencePanel from "./IntelligencePanel";
import ObdMasterTable from "./ObdMasterTable";

export default function EIS() {
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [activeTab, setActiveTab] = useState("raw");
  const [viewMode, setViewMode] = useState("brand"); // "brand" or "master"

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">

      {/* LEFT SIDEBAR */}
      <EISSidebar
        onSelect={(brand, model) => {
          setSelectedBrand(brand);
          setSelectedModel(model);
          setViewMode("brand");
        }}
        onOpenMaster={() => setViewMode("master")}
      />

      {/* RIGHT CONTENT */}
      <div className="flex-1 overflow-y-auto h-screen p-8 bg-slate-50/50">

        {viewMode === "master" ? (
          <ObdMasterTable />
        ) : (
          !selectedBrand || !selectedModel ? (
            <div className="text-slate-400 font-bold text-sm">
              Select a brand & model to view EIS data
            </div>
          ) : (
            <>
              {/* HEADER */}
              <div className="flex justify-between items-center mb-6">
                <div>
                  <h1 className="text-xl font-black text-slate-900">
                    {selectedBrand} / {selectedModel}
                  </h1>
                  <p className="text-xs text-slate-400 uppercase font-bold">
                    Engineering Intelligence System
                  </p>
                </div>

                <div className="flex gap-2">
                  {["raw", "parameters", "obd", "notes"].map(t => (
                    <button
                      key={t}
                      onClick={() => setActiveTab(t)}
                      className={`px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase
                        ${activeTab === t
                          ? "bg-slate-900 text-white"
                          : "bg-white border text-slate-500"}`}
                    >
                      {t}
                    </button>
                  ))}
                </div>
              </div>

              {/* TAB CONTENT */}
              {activeTab === "raw" && (
                <RawDataTable brand={selectedBrand} model={selectedModel} />
              )}

              {activeTab === "parameters" && (
                <ParametersTable brand={selectedBrand} model={selectedModel} />
              )}

              {activeTab === "obd" && (
                <ObdUsedPanel brand={selectedBrand} model={selectedModel} />
              )}

              {activeTab === "notes" && (
                <NotesPanel brand={selectedBrand} model={selectedModel} />
              )}
            </>
          )
        )}
      </div>
    </div>
  );
}
